import { Box } from "@mui/material";

export const materialOrderGridListSx = {
  width: "100%",
  "& .material-order-grid-group": {
    backgroundColor: "background.paper",
    border: "1px solid rgba(0, 0, 0, 0.28)",
    borderRadius: 1,
    mt: 2,
    overflow: "hidden",
  },
  "& .material-order-grid-group .MuiDataGrid-root": {
    border: 0,
  },
  "& .material-order-grid-group .MuiDataGrid-columnHeaders": {
    borderBottom: "1px solid rgba(0, 0, 0, 0.18)",
  },
  "& .material-order-grid-group .MuiDataGrid-columnHeader[data-field='name'] .MuiDataGrid-columnHeaderTitle, & .material-order-grid-group .MuiDataGrid-columnHeader[data-field='materialName'] .MuiDataGrid-columnHeaderTitle":
    {
      fontWeight: 700,
      textTransform: "uppercase",
    },
  "& .material-order-grid-group .MuiDataGrid-row:last-of-type": {
    borderBottom: 0,
  },
  "& .material-order-grid-group + .material-order-grid-group": {
    mt: 2,
  },
};

export const MaterialOrderGridGroup = ({ children }) => (
  <Box className="material-order-grid-group">{children}</Box>
);
